jQuery(document).ready(function($) {
  require('./components/mobile-header.js');
  require('./components/slider.js');
  require('./components/header-scroll.js');
  require('./components/accordion.js');

  loadMorePosts.init();
});


AOS.init();


// Category Filter
jQuery(document).ready(function($) {
  $('#category-select li').on('click', function() {

    $('#category-select li').removeClass('active');
    $(this).addClass('active');

    var selectedTag = $(this).data('tag');
    console.log(selectedTag);

    $.ajax({
      type: 'POST',
      url: posts.ajaxurl,
      data: {
        action: 'filter_posts',
        tag: selectedTag,
      },

      success: function(response) {
        $('#load-posts-container').html(response);

        if(selectedTag !== 'all') {
          $('.button-container').hide();

        } else {
          $('.button-container').show();
        }
      },
    });
  });
});


// Load More Posts
var loadMorePosts = {
	init: function() {
    jQuery('#load-more').click(function(){
      loadMorePosts.loadMore();
    });
	},

	loadMore: function() {
		var loadContainer = jQuery('#load-posts-container');
		var postCount = jQuery('#load-posts-container .post-thumbnail').length;
		var totalPosts = loadContainer.data('total');

		if(postCount >= totalPosts) {
			return;
		}

		var data = {
      action: 'load_more_posts',
      post_count: postCount,
      post_search: posts.s,
      current_taxonomy: posts.current_taxonomy,
      current_term: posts.current_term,
      current_child_term: posts.current_child_term,
		};

		jQuery.ajax({
			url: posts.ajaxurl,
			type: "POST",
			data: data,
			beforeSend: function () {

				// Request for posts

				jQuery('#load-more').addClass('loading');
			},
			complete: function () {

				// Request for posts received / response is being sent back to us

				jQuery('#load-more').removeClass('loading');
			},
			success: function(data) {

				// We get posts back / successful response

				if(data) {
          loadContainer.append(data);
				}

				postCount = jQuery('#load-posts-container .post-thumbnail').length;

				if(postCount >= totalPosts) {
          jQuery('#load-more').replaceWith('<a class="frontend-button load-button" href="#blog-top">Back To Top</a>');
				}

				return;
			}
		});
	}
}


// Pricing Row Heights
document.addEventListener("DOMContentLoaded", function() {
  var singlePricingColumns = document.querySelectorAll('.single-pricing');
    
  function adjustRowHeights(columnsPerGroup) {
    for(var i = 0; i < singlePricingColumns.length; i += columnsPerGroup) {
      var groupColumns = Array.from(singlePricingColumns).slice(i, i + columnsPerGroup);
      var columnGroups = {};

      groupColumns.forEach(function(column) {
        var rows = column.querySelectorAll('.info, .centered, .additional-info');

        rows.forEach(function(row) {
          var rowClass = row.classList[0];

          if(!columnGroups[rowClass]) {
            columnGroups[rowClass] = [];
          }

          columnGroups[rowClass].push(row);
        });
      });

      Object.keys(columnGroups).forEach(function(rowClass) {
        var rows = columnGroups[rowClass];
        var tallestRowHeight = 0;

        rows.forEach(function(row) {
          row.style.height = '';
          var rowHeight = row.offsetHeight;

          if(rowHeight > tallestRowHeight) {
            tallestRowHeight = rowHeight;
          }
        });

        rows.forEach(function(row) {
          row.style.height = tallestRowHeight + 'px';
        });
      });
    }
  }

  function handleResize() {
    var screenWidth = window.innerWidth;

    if(screenWidth <= 1200 && screenWidth > 650) {
      adjustRowHeights(2);

    } else if (screenWidth <= 650) {
      adjustRowHeights(1);

    } else {
      adjustRowHeights(4);
    }
  }

  handleResize();

  window.addEventListener('resize', handleResize);
});


// Centered UL
function addClassToCenteredUl() {
  var ulElements = document.querySelectorAll('.wysiwyg ul');

  ulElements.forEach(function(ul) {
    var liElements = ul.querySelectorAll('li');

    liElements.forEach(function(li) {
      var computedStyle = window.getComputedStyle(li);

      if(computedStyle.getPropertyValue('text-align') === 'center') {
        ul.classList.add('centered-ul');
      }
    });
  });
}

addClassToCenteredUl();